module.exports = __webpack_public_path__ + "assets/img/jenkins_add_step.e28cc1b8.png";